<template>
  <ev-config-panel class="solver-page" />
</template>

<script>
import EvConfigPanel from "../components/config/EvConfigPanel";

export default {
  components: { EvConfigPanel }
};
</script>

<style lang="less" scoped>
.solver-page {
  flex: 1;
  min-height: 0;
}
</style>
